@if (control()) {
  <div class="password-info">
    <div class="strength-bar">
      @for (rule of allRules; track $index) {
        <div
          [class.active]="$index < fulfilledCount"
          [class.neutral]="isNeutral()"
          class="segment"
          [attr.data-testid]="testIds.passwordSegment"></div>
      }
    </div>

    @for (rule of allRules; track $index) {
      <div
        [class.invalid]="isInvalid(rule.key)"
        [class.valid]="isValid(rule.key)"
        class="info-wrapper"
        [attr.data-testid]="testIds.rule">
        @if (isValid(rule.key)) {
          <mat-icon [attr.data-testid]="testIds.ruleSucces" class="check" svgIcon="check-circle"></mat-icon>
        }
        @if (isInvalid(rule.key) || isNeutral()) {
          <mat-icon [attr.data-testid]="testIds.ruleError" class="error" svgIcon="circle-error-grey"></mat-icon>
        }
        <span [attr.data-testid]="testIds.ruleText" class="text">
          {{ rule.label }}
        </span>
      </div>
    }
  </div>
}
